<template>
    <div style="background: #77CBF0;width:100%">
        <div class="contentBtm">
            <div class="contentBtmLeft">
                <div class="btmLeft">
                    <div style="font-size: 22px">联系方式</div>
                    <div>Contact Us</div>
                </div>
            </div>
            <div class="contentBtmRight">
                <div class="phone">
                    <div class="width1">
                        <span class="spanImg"><i class="el-icon-phone-outline"></i></span>
                        <span class="spanTel">电话：0518-85881898</span>
                    </div>
                    <div class="width3">
                        <span class="spanImg"><i class="el-icon-postcard"></i></span>
                        <span class="spanTel">备案号：<a href="http://www.beian.miit.gov.cn/" target="_black">苏ICP备20031506号</a></span>
                    </div>
                     <div class="width2">
                        <span class="spanImg"><i class="el-icon-location-outline"></i></span>
                        <span class="spanTel">地址1：连云港市灌云经济开发区纬三路30号（灌云）</span>
                    </div>
                    
                    <div class="width1">
                        <span class="spanImg"><i class="el-icon-position"></i></span>
                        <span class="spanTel">邮编：222000</span>
                    </div>
                    <div class="width3">
                        <span class="spanImg"><i class="el-icon-message"></i></span>
                        <span class="spanTel">邮箱：gerunhb857@163.com</span>
                    </div>
                    <div class="width2">
                        <span class="spanImg"><i class="el-icon-location-outline"></i></span>
                        <span class="spanTel">地址2：连云港市海州区朝阳东路32-6东盛阳光大厦B座408</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name:'bottom',
    }
</script>  
<style scoped>
    .contentBtm{
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;
        padding: 50px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: left;
    }
    .contentBtmLeft{
        width: 15%;
        border-right: 1px solid #fff;
        overflow:hidden;
        display: flex;
        align-items: center;
    }
    .contentBtmRight{
        width: 80%;
        display: flex;
        align-items: center;
    }
    .btmLeft{
        width: 59%;
        display: inline-block;
        text-align: center;
        color: #fff
    }
    .btmLeft p{
        font-size: 18px;
    }
    .btmRight{
        width: 40%;
        display: inline-block;
    }
    .btmRight span{
        width: 20%;
        display: inline-block;
    }
    .btmRight span img{
        width: 100%
    }
    .phone{
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        padding: 20px 0;
    }
    .spanImg i {
        color: white;
        margin-right: 5px;
    }
    .spanTel{
        color: #fff;
    }
    .spanTel a {
        color: white;
        text-decoration: none;
    }
    .width1 {
        width: 23%;
        padding: 5px 0;
    }
    .width3 {
        width: 30%;
        padding: 5px 0;
    }
    .width2 {
        width: 47%;
        padding: 5px 0;
    }
</style>